import * as React from "react"
import { useStaticQuery, graphql } from "gatsby"
import BlogCard from "./blogCard"
import { Lang, LangEnum } from "../utils/lang"

const BlogList = ({blogs, category, keyword, label}) => {
  // const { enBlogs, jaBlogs } = useStaticQuery(graphql`
  // query Blogs {
  //   enBlogs: allStoryblokEntry(
  //     filter: {field_component: {eq: "blogArticle"}, full_slug: {regex: "/^blog/"}}
  //     sort: {published_at: DESC}
  //     limit: 200
  //   ) {
  //     edges {
  //       node {
  //         name
  //         full_slug
  //         content
  //         field_component
  //         published_at(formatString: "MM/DD/YYYY")
  //         first_published_at(formatString: "MM/DD/YYYY")
  //       }
  //     }
  //   }
  
  //   jaBlogs: allStoryblokEntry(
  //     filter: {field_component: {eq: "blogArticle"}, full_slug: {regex: "/^ja/blog/"}}
  //     sort: {published_at: DESC}
  //     limit: 200
  //   ) {
  //     edges {
  //       node {
  //         name
  //         full_slug
  //         content
  //         field_component
  //         published_at(formatString: "MM/DD/YYYY")
  //         first_published_at(formatString: "MM/DD/YYYY")
  //       }
  //     }
  //   }
  // }`)
  // const lang = Lang()
  // const blogs = lang === LangEnum.JA ? jaBlogs : enBlogs

  // blogs.edges.forEach((e) => {
  //   e.node.content = typeof e.node.content === 'string' ? JSON.parse(e.node.content) : e.node.content;
  // })
  // console.log(blogs)

  return (
  <div className="container mx-auto my-10">
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-10">
    { blogs &&
      blogs
      .filter((e) => {
        if (!category) return true;
        if (!e.content.category) return false;
        return e.content.category?.some((c) => c.name === category);
      })
      .filter((e) => {
        if (!label) return true;
        return label.every((l) => e.content?.label?.value?.includes(l))
      })
      .filter((e) => {
        if (!keyword) return true;
        return e.name?.toLowerCase().includes(keyword) 
            || e.content?.title?.toLowerCase().includes(keyword)
            || e.content?.subHeading?.toLowerCase().includes(keyword)
            || e.content?.label?.value?.join(',').toLowerCase().includes(keyword)
      })
      .map((e, i) => {            
        return (
        <div key={i} className="min-h-[480px] rounded-lg">
          <BlogCard blok={e} />
        </div>
        )
      })
    }
    </div>
  </div>
  )
}

export default BlogList
